var map = {
	"./arrow-selected.png": 1608,
	"./arrow.png": 4522,
	"./blank.png": 7185,
	"./caterpillar.png": 7662,
	"./extra-spritesheets/CyberFreaksB.png": 8847,
	"./extra-spritesheets/bomber-32-rules.png": 7325,
	"./extra-spritesheets/bomber-32.png": 8793,
	"./extra-spritesheets/bomber2.png": 7486,
	"./extra-spritesheets/bomber3.png": 3560,
	"./extra-spritesheets/caterpillar-old.png": 675,
	"./extra-spritesheets/desert.png": 896,
	"./extra-spritesheets/snake-32x32.png": 4608,
	"./extra-spritesheets/snake-original-16x16.png": 344,
	"./extra-spritesheets/snake-segmented.png": 7497,
	"./maze.png": 6248,
	"./mines.png": 7504,
	"./mushrooms.png": 2251,
	"./ninja.png": 2574,
	"./no-fill.png": 7962,
	"./owls.png": 8513,
	"./shapes.png": 2917,
	"./snake.png": 2125,
	"./specials.png": 4945,
	"./tetris.png": 790,
	"./zzt.png": 3940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7183;